module.exports = __webpack_public_path__ + "static/media/control-icon.afad2813.svg";